import React from 'react';
import * as Icons from '@material-ui/icons';

export default function Icon(props) {
  const IconComponent = Icons[props.name] || Icons.HelpOutline;
  return <IconComponent {...props} />
}
